import { FormEsasFilledByEnum } from '../../../types/src/services/enum/form-esas-filled-by.enum';
import { FormSetEnum } from '../../../types/src/services/enum/form-set.enum';
import { JsonObject } from '@angular-devkit/core';
import { FormsTotalPoints } from '@libs/shared/form-helpers/forms/forms-total-points';
import { FormsOtherHelpers } from '@libs/shared/form-helpers/forms/forms-other-helpers';
import { FormsMapValueToText } from '@libs/shared/form-helpers/forms/forms-map-value-to-text';

export class FormsFinalEvaluation {

    public static get(formData: string, formSetType: string, onlyValue = true): string {
        const formDataJson = JSON.parse(formData);
        switch(formSetType) {
            case FormSetEnum.BI:
                return this.getForBi(formDataJson, onlyValue);
            case FormSetEnum.DEKN:
                return this.getForDekn(formDataJson, onlyValue);
            case FormSetEnum.ESAS:
                return this.getForEsas(formDataJson);
            case FormSetEnum.IADL:
                return this.getForIadl(formDataJson, onlyValue);
            case FormSetEnum.MSSE:
                return this.getForMsse(formDataJson);
            case FormSetEnum.NI:
                return this.getForNi(formDataJson, onlyValue);
            case FormSetEnum.PPS:
                return this.getForPps(formDataJson);
            case FormSetEnum.RVD:
                return this.getForRvd(formDataJson, onlyValue);
            default:
                return '';
        }
    }

    public static getForBi(formData: JsonObject, onlyValue = true): string {
        const totalPoints = FormsTotalPoints.getForBi(formData);
        let value = 'nezávislý';
        if (totalPoints < 45) {
            value = 'vysoce závislý';
        } else if (totalPoints < 65) {
            value = 'závislost středního stupně';
        } else if (totalPoints < 100) {
            value = 'lehká závislost';
        }
        return onlyValue ? value : `Stupeň závislosti = ${value}`;
    }

    public static getForDekn(formData: JsonObject, onlyValue = true): string {
        const totalPoints = FormsTotalPoints.getForDekn(formData);
        let value = 'snížené riziko';
        if (totalPoints < 25) {
            value = 'vysoké riziko';
        }
        return onlyValue ? value : `Stupeň závislosti = ${value}`;
    }

    public static getForEsas(formData: JsonObject): string {
        const data = [
            'Bolest = ' + (Number(formData.pain) !== -1 ? formData.pain : 'Neznámo'),
            'Únava = ' + (Number(formData.fatigue) !== -1 ? formData.fatigue : 'Neznámo'),
            'Ospalost = ' + (Number(formData.sleepiness) !== -1 ? formData.sleepiness : 'Neznámo'),
            'Nevolnost = ' + (Number(formData.nausea) !== -1 ? formData.nausea : 'Neznámo'),
            'Nechutenství = ' + (Number(formData.distaste) !== -1 ? formData.distaste : 'Neznámo'),
            'Dušnost = ' + (Number(formData.shortnessOfBreath) !== -1 ? formData.shortnessOfBreath : 'Neznámo'),
            'Deprese = ' + (Number(formData.depression) !== -1 ? formData.depression : 'Neznámo'),
            'Úzkost = ' + (Number(formData.anxiety) !== -1 ? formData.anxiety : 'Neznámo'),
            'Celková pohoda = ' + (Number(formData.wellBeing) !== -1 ? formData.wellBeing : 'Neznámo'),
            'Další problémy = ' + (Number(formData.other) !== -1 ? formData.other : 'Neznámo'),
            'Vyplnil = ' + FormsOtherHelpers.mapEsasFilledByToText(formData.filledBy as FormEsasFilledByEnum),
        ];
        return data.join(', ');
    }

    public static getForIadl(formData: JsonObject, onlyValue = true): string {
        const totalPoints = FormsTotalPoints.getForIadl(formData);
        let value = 'nezávislý';
        if (totalPoints < 41) {
            value = 'závislý';
        } else if (totalPoints < 76) {
            value = 'částečně závislý';
        }
        return onlyValue ? value : `Stupeň závislosti = ${value}`;
    }

    public static getForMsse(formData: JsonObject): string {
        const data = [
            'Neklid = ' + (formData.restlessness ? 'Ano' : 'Ne'),
            'Výkřiky = ' + (formData.shouts ? 'Ano' : 'Ne'),
            'Bolest = ' + (formData.pain ? 'Ano' : 'Ne'),
            'Dekubity = ' + (formData.decubitus ? 'Ano' : 'Ne'),
            'Malnutrice = ' + (formData.malnutrition ? 'Ano' : 'Ne'),
            'Poruchy stravování (nechutenství - dysfagie) = ' + (formData.eatingDisorders ? 'Ano' : 'Ne'),
            'Konfliktní chování = ' + (formData.conflictBehavior ? 'Ano' : 'Ne'),
            'Labilní zdravotní stav = ' + (formData.unstableStateOfHealth ? 'Ano' : 'Ne'),
            'Utrpení podle zdravotníka = ' + (formData.sufferingAccordingToMedic ? 'Ano' : 'Ne'),
            'Utrpení podle pečující osoby = ' + (formData.sufferingAccordingToCaregiver ? 'Ano' : 'Ne'),
        ];
        return data.join(', ');
    }

    public static getForNi(formData: JsonObject, onlyValue = true): string {
        const totalPoints = FormsTotalPoints.getForNi(formData);
        let value = 'nezávislý';
        if (totalPoints < 45) {
            value = 'vysoce závislý';
        } else if (totalPoints < 65) {
            value = 'závislost středního stupně';
        } else if (totalPoints < 100) {
            value = 'lehká závislost';
        }
        return onlyValue ? value : `Stupeň závislosti = ${value}`;
    }

    public static getForPps(formData: JsonObject): string {
        const totalPoints = FormsTotalPoints.getForPps(formData);
        const data = [
            'Pohyblivost = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'mobility'),
            'Aktivita = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'activity'),
            'Symptomy nemoci = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'illnessSymptoms'),
            'Soběstačnost = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'selfSufficiency'),
            'Příjem potravy = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'foodIntake'),
            'Stav vědomí = ' + FormsMapValueToText.mapPpsValueToText(totalPoints, 'stateOfConsciousness'),
        ];
        return data.join(', ');
    }

    public static getForRvd(formData: JsonObject, onlyValue = true): string {
        const totalPoints = FormsTotalPoints.getForRvd(formData);
        let value = 'nízké';
        if (totalPoints < 12) {
            value = 'vysoké';
        } else if (totalPoints < 14) {
            value = 'střední';
        }
        return onlyValue ? value : `Riziko = ${value}`;
    }
}
